export default "__VITE_ASSET__CJLDv$5L__"